import { render } from "./ManageAllView.vue?vue&type=template&id=affaad52"
import script from "./ManageAllView.vue?vue&type=script&lang=js"
export * from "./ManageAllView.vue?vue&type=script&lang=js"

import "./ManageAllView.vue?vue&type=style&index=0&id=affaad52&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__